export const qmeStatusOptions = [
  { id: 1, label: 'Open', className: 'initiated' },
  { id: 2, label: 'WIP', className: 'launched' },
  { id: 3, label: 'On-Hold', className: 'draft' },
  { id: 4, label: 'Closed', className: 'completed' },
];
export const qmeDateTimeFormat = 'MMM DD, YYYY HH:mm';
export const qmeProgressOptions = [25, 50, 75, 100];

export const qmeTrackerHd = [
  { label: 'Action(s)', sortOption: false, actionCell: true, sticky: true, width: '90px' },
  { id: 'project_number', label: 'Project / Claim Reference', sortOption: true, width: '220px' },
  { id: 'sysco_claim_number', label: 'SYSCO Claim Number', sortOption: true, width: '170px' },
  { id: 'msn', label: 'MSN', sortOption: false, width: '240px' },
  { id: 'location', label: 'Location', sortOption: true, width: '140px' },
  { label: 'Component S/N(s)', sortOption: false, width: '420px' },
  { id: 'mro_facility', label: 'MRO Facility', sortOption: true, width: '140px' },
  { id: 'lessee', label: 'Lessee', sortOption: true, width: '140px' },
  { id: 'qme_type', label: 'QME Type', sortOption: true, width: '180px' },
  { id: 'workscope', label: 'Workscope / Event', sortOption: true, width: '180px' },
  { label: 'Assigned To', sortOption: false, width: '360px' },
  { id: 'start_date', label: 'Start Date', sortOption: true, width: '120px' },
  { id: 'target_date', label: 'Target Date', sortOption: true, width: '120px' },
  { id: 'status', label: 'Status', sortOption: true, width: '110px' },
  { id: 'progress', label: 'Progress (%)', sortOption: true, width: '140px' },
  { id: 'last_updated', label: 'Last Updated', sortOption: true, width: '170px' },
  { id: 'next_action', label: 'Next Action / Due', sortOption: true, width: '180px' },
  { id: 'vendor_remarks', label: 'Vendor Remarks', sortOption: true, width: '180px' },
  { id: 'client_remarks', label: 'CSL Remarks', sortOption: true, width: '180px' },
];

export const qmeFilterOps = {
  'search': {
    'inputType': 'text',
    'title': 'Search'
  },
  'qme_type': {
    'inputType': 'dropdown',
    'title': 'QME Type',
    'options': [],
    'labelKey': 'label',
    'valueKey': 'value',
    'multiple': true
  },
  'lessee': {
    'inputType': 'dropdown',
    'title': 'Lessee',
    'options': [],
    'labelKey': 'name',
    'valueKey': 'id',
    'multiple': true
  },
};
